import { type Lens } from '@dhmk/zustand-lens';

import { type Store } from '../models/store/store';

type State = {
  store?: Store;
};

type Actions = {
  setStore: (store: Store) => void;
  reset: () => void;
};

export type LocationSlice = State & Actions;

type Slice = { location: LocationSlice };

export class LocationStore {
  createSlice = (initialState: State = {}) => {
    const state: Lens<LocationSlice> = (set) => ({
      reset: () => {
        set(() => ({
          store: undefined,
        }));
      },

      setStore: (store) => set({ store }),
      ...initialState,
    });
    return state;
  };

  partialize = ({ location }: Slice) => ({
    ...location,
  });
}

export const selectStore = ({ location }: Slice) => ({
  setStore: location.setStore,
  store: location.store,
});
